
import { baseUrl } from "../../constants";
import { getDDDeptCall } from "../../redux/actions/dropDown";
import { setFullLoad } from "../../redux/actions/common";

export default {
    "formTitle": "Add User Role",
    "tableTitle": "User Role List",
    "apiDetails": {
        startUp: (dispatch) => {
            dispatch(setFullLoad(true));
            const dropDownArr = [
                getDDDeptCall,
            ];
            setTimeout(()=>{
                dispatch(setFullLoad(false));
            }, 500);
            dropDownArr.forEach((func,) => {
                    dispatch(func());
            });
        },
        list: {
            url: `${baseUrl}/api/mms/userRole/list`,
            payload: {
                "search": "",
                "offset": 0,
                "limit": 50,
                "sort": "DESC",
                "column": "id"
            }
        },
        add: `${baseUrl}/api/mms/userRole`,
        edit: `${baseUrl}/api/mms/userRole/edit`,
        delete: `${baseUrl}/api/mms/userRole/remove`
    },
    "tableCol": [
        {
            name: 'Role Name',
            selector: row => row.name,
            sortable: true
        },
        {
            name: 'Access List',
            selector: row => row.roles,
            sortable: true
        },
        {
            name: 'Status',
            selector: row => row.status,
            sortable: true
        }
    ],
    "formData": [
        {
            "formType": "flex",
            "formFields": [
                {
                    type: 'text',
                    label: 'Role Name',
                    name: 'roleName',
                    // "required": true
                },
                {
                    type: 'multiSelect',
                    label: 'Access List',
                    name: 'roles',
                    // "required": true
                },
                {
                    type: 'switch',
                    label: 'Status',
                    name: 'status',
                    "options": [],
                    // "required": true
                }
            ]
        }
    ],
    "mockData": [{
        "roleName": "Kumar",
        "roles": ["code007"],
        "status": 1
    }]
}